import React, {Component} from 'react';
import {Box} from 'reactjs-admin-lte'
import {Button,ButtonToolbar,DropdownButton,SplitButton,MenuItem,ControlLabel,InputGroup,FormGroup,Row,Col,Form,FormControl,Tabs,Tab} from 'react-bootstrap'
import Select from 'react-select';
import FontAwsome from 'react-fontawesome'
import { Checkbox, Radio } from 'react-icheck';
import WorkdocStore from '../../stores/WorkdocStore';
import SWTNewCarButton from './SWTNewCarButton';
import SWTCarEditPopup from './SWTCarEditModal'
import SWTNewCustomerPopup from '../workdoc/SWTNewCustomerModal';
import './WorkDoc.css';
import FormJsonSchema from "react-jsonschema-form";
import LayoutField from "react-jsonschema-form-layout";

var NotificationSystem = require('react-notification-system');

/*
class ModelYearCar extends Component {
  constructor(props) {
    super(props);
    this.state = { ...props.formData };
    console.log('model',this.props)
  }

  onChange(name) {
    return event => {
      this.setState({ [name]: event.value });
      setImmediate(() => this.props.onChange(this.state));
    };
  }

  render() {
    const { model, year } = this.state;
    let modelOption = [
      {
        label:"CITY",
        value:"CITY"
      },
      {
        label:"CIVIC",
        value:"CIVIC"
      },
      {
        label:"CR-V",
        value:"CR-V"
      }
    ]
    let yearOption = [
      {
        label:"2017",
        value:"2017"
      },
      {
        label:"2016",
        value:"2016"
      },
      {
        label:"2015",
        value:"2015"
      }
    ]
    return (
      <div className="geo">        
        <div className="row">
          <div className="col-sm-6">
            <ControlLabel>รุ่น</ControlLabel>
            <Select
              clearable={false}
              name="form-field-name"
              value={model}
              options={modelOption}
              onChange={this.onChange("model")}
            >
            </Select>
          </div>
          <div className="col-sm-6">
            <ControlLabel>ปี</ControlLabel>
            <Select
              clearable={false}
              name="form-field-name"
              value={year}
              options={yearOption}
              onChange={this.onChange("year")}
            >
            </Select>
          </div>
        </div>
      </div>
    );
  }
}
*/
function CustomFieldTemplate(props) {
  const {id, classNames, label, help, required, description, errors, children} = props;
  let requiredLabel = null
  if(required){
    requiredLabel  = (<label className="text-red">*</label>)
  }
  return (
    <div className={classNames}>
      <label htmlFor={id}>{label}{requiredLabel}</label>
      {description}
      {children}
      {errors}
      {help}
    </div>
  );
}

class WorkDocGenForm extends Component {

  constructor(...args){
    super(...args)
    this.state = {formData:{model:'CITY',year:'2017',license_car:'ABC',number_car_body:'123'},
      schema:{
        title: "",
        type: "object",
        required: ["license_car","type_car","color_car"],
        properties: {
          license_car: {type: "string", title: "ทะเบียนรถ", default: ""},
          type_car: {type: "string", title: "ประเภทรถ", default: "รถเก๋ง", enum: ["รถเก๋ง", "รถกระบะ", "รู้ตู้"]},
          model :{type: "string", title: "ประเภทรถ", default: "รถเก๋ง", enum: ["CITY", "CIVIC", "CRV"]},
          year :{type: "string", title: "ประเภทรถ", default: "รถเก๋ง", enum: ["2017", "2016", "2015"]},
          color_car: {type: "string", title: "สีรถ", default: "สีดำ", enum: ["สีดำ", "สีขาว", "สีเงิน"]},
          number_car_body: {type: "string", title: "หมายเลขตัวถัง", default: ""},
          repair_order_out: {type: "string", title: "เลขที่ใบสั่งซ่อม (ภายนอก)", default: ""},        
        }
      },
      uiSchema:{      
        'ui:field': 'layout',
        'ui:layout': [
          {
            license_car: { md: 12 },
            type_car: { md: 12 },
            model:{md:6},
            year:{md:6},
            color_car:{md:12},
            number_car_body:{md:12},
            repair_order_out:{md:12},
          }
        ]
      }
    }
    this.state = {
      formData:{
        model:'CITY',year:'2017',
        car_registration_no:'ABC',
        chassis_no:'123'
      },
      showCarPopup:false,
      showCustomerPopup:false
    }
  }

  onSaveClick(){
    
    let {formData} = this.state
    console.log("formData",formData)

    
  }

  onFormChange(e){
    let {schema,uiSchema} = this.state
    let {formData} =e
    
    if(formData.model==='CIVIC'){
      formData.year="2016"
      formData.license_car = "678"
      schema.properties.year.enum = ["2015", "2014", "2013"]      
    }

    console.log('onFormChanage',formData,schema,uiSchema)
        
      
    this.setState({formData:formData,schema:schema})
    
    
  }

  onCarPopupClick(e) {
    let {showCarPopup} = this.state
    this.setState({showCarPopup:true})
  }

  onCustomerPopupClick(e) {
    let {showCustomerPopup} = this.state
    this.setState({showCustomerPopup:true})
  }

  renderButtonCar() {
    return(
      <InputGroup.Addon 
        className="btn"
        onClick={this.onCarPopupClick.bind(this)}
      >
        <FontAwsome name='plus' />
      </InputGroup.Addon>
    )
  }

  renderButtonCustomer() {
    return(
      <InputGroup.Addon 
        className="btn"
        onClick={this.onCustomerPopupClick.bind(this)}
      >
        <FontAwsome name='plus' />
      </InputGroup.Addon>
    )
  }

  render() {
    let titleTab1 = (<div><FontAwsome name="car" />&nbsp;ข้อมูลรถยนต์</div>)
    let titleTab2 = (<div><FontAwsome name="user" />&nbsp;ข้อมูลลูกค้า</div>)
    let titleTab3 = (<div><FontAwsome name="check-square-o" />&nbsp;รับรถเข้าซ่อม</div>)
    let titleTab4 = (<div><FontAwsome name="smile-o" />&nbsp;ส่งมอบรถ</div>)
    return(
      <div>
        <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
          <Tab eventKey={1} title={titleTab1}>{this.renderTab1()}</Tab>
          <Tab eventKey={2} title={titleTab2}>{this.renderTab2()}</Tab>
          <Tab eventKey={3} title={titleTab3}>{this.renderTab3()}</Tab>
          <Tab eventKey={4} title={titleTab4}>{this.renderTab4()}</Tab>
        </Tabs> 
      </div>
    )
  }

  renderTab1() {
    let that = this
    let {formData,schema,uiSchema} = this.state    
    const setBrand = function(props) {
      let brandOption = [
        {
          label:"HONDA",
          value:"HONDA"
        },
        {
          label:"TOYOTA",
          value:"TOYOTA"
        }
      ]
      return (
              <FormGroup>                
                <InputGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value="HONDA"
                    options={brandOption}
                  >
                  </Select>
                  {that.renderButtonCar()}                  
                </InputGroup>
              </FormGroup>
            
      )    
    }
    const setSeries = function(props) {
      let seriesOption = [
        {
          label:"(ปี 02-05)",
          value:"(ปี 02-05)"
        },
        {
          label:"(ปี 08-14)",
          value:"(ปี 08-14)"
        }
      ]
      return (
        
              <FormGroup>                
                <InputGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value="(ปี 02-05)"
                    options={seriesOption}
                  >
                  </Select>
                  <InputGroup.Addon 
                    className="btn"
                  >
                    <FontAwsome name='plus' />
                  </InputGroup.Addon>
                </InputGroup>
              </FormGroup>            
      )    
    } 
    const schema1 = {
      title: "",
      type: "object",
      required: ["car_registration_no","car_type","car_color"],
      properties: {
        car_registration_no: {type: "string", title: "ทะเบียนรถ", default: ""},
        car_type: {type: "string", title: "ประเภทรถ", default: "รถเก๋ง", enum: ["รถเก๋ง", "รถกระบะ", "รู้ตู้"]},
        model :{type: "string", title: "รุ่น", default: "รถเก๋ง", enum: ["CITY", "CIVIC", "CR-V"]},
        year :{type: "string", title: "ปี", default: "รถเก๋ง", enum: ["2017", "2016", "2015"]},
        car_color: {type: "string", title: "สีรถ", default: "สีดำ", enum: ["สีดำ", "สีขาว", "สีเงิน"]},
        chassis_no: {type: "string", title: "หมายเลขตัวถัง", default: ""},
        pr_fix_no: {type: "string", title: "เลขที่ใบสั่งซ่อม (ภายนอก)", default: ""},      
        
        province: {type: "string", title: "จังหวัด", default: "กรุงเทพมหานคร", enum: ["กรุงเทพมหานคร", "ชลบุรี"]},
        brand: {type: "object", title: "ยี่ห้อ"},
        series: {type: "object", title: "โฉมปี (แบบ)"},
        mileage: {type: "string", title: "หมายเลข กม.", default: ""},
        engine_no: {type: "string", title: "หมายเลขเครื่อง", default: ""},
      }
    } 

    const uiSchema1 = {
      'ui:field': 'layout',
      'ui:layout': [
        {
          car_registration_no:{md:6},
          province:{md:6},
        },{
          car_type: {md:6},
          brand:{md:6},
        },{
          model:{md:3},
          year:{md:3},
          series:{md:6},
        },{
          car_color:{md:6},
          mileage:{md:6},
        },{
          chassis_no:{md:6},
          engine_no:{md:6},
        },{
          pr_fix_no:{md:6},
        }        
      ],
      brand: {
        'ui:field': 'customBrand'
      },
      series: {
        'ui:field': 'customSeries'
      }
    }
    const fields1 = {      
      layout: LayoutField,
      customBrand: setBrand,
      customSeries: setSeries
      
    }
    return(
          <Box loading={false}>
            <Box.Header>
              <Box.Title border={true}>
                <FontAwsome className="text-blue" name="car" /> รายละเอียดรถยนต์
              </Box.Title>  
            </Box.Header>
            <Box.Body>
              <Row>
                <Col md={12}>
                  <FormJsonSchema 
                    schema={schema1}
                    uiSchema={uiSchema1}
                    fields={fields1}
                    formData={formData}
                    FieldTemplate={CustomFieldTemplate}         
                    onChange={this.onFormChange.bind(this)}
                  >
                    <div></div>
                  </FormJsonSchema>                
                </Col>
              </Row>
              <div className="pull-right">
                <Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;บันทึก</Button>
                &nbsp;
                <Button className="btn btn-default"><FontAwsome name='close' />&nbsp;ปิดใบงาน</Button>
              </div>
              <SWTCarEditPopup
                show={this.state.showCarPopup}
                onHide={()=>{this.setState({showCarPopup:false})}}
              >
              </SWTCarEditPopup>
            </Box.Body>
          </Box>
    )
  }

  renderTab2() {
    let that = this
    const schema2 = {
      title: "",
      type: "object",
      required: ["title","tel"],
      properties: {
        title: {type: "string", title: "ชื่อลูกค้า", default: "นาย", enum: ["นาย", "นาง", "นางสาว", "บจก.", "หจก."]},
        name: {type: "object"},
        pay_type: {type: "object", title: "ประเภท"},
        tel: {type: "string", title: "หมายเลขโทรศัพท์"},
        other_tel: {type: "string", title: "เบอร์ติดต่ออื่น"}
      }
    }
    const uiSchema2 = {
      'ui:field': 'layout',
      'ui:layout': [
        { 
          title:{md:2},
          name:{md:4},
          tel:{md:6}
        },
        {
          pay_type:{md:6},
          other_tel:{md:6}
        }       
      ],
      name: {
        'ui:field': 'customName',
        'ui:title': true
      },
      pay_type: {
        'ui:field': 'customPayType',
      },
    }
    const setName = function(props) {
      return(
              <FormGroup style={{marginTop:'10px'}}>             
                <InputGroup>
                  <FormControl

                  >
                  </FormControl>
                  {that.renderButtonCustomer()}
                </InputGroup>
              </FormGroup>
      )
    }
    const setPayType = function(props) {
      return(
              <FormGroup>
                <Radio
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label=" เครดิต"
                />
                {' '}
                <Radio
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label=" เงินสด"
                />
              </FormGroup>
      )
    }
    const fields2 = {      
      layout: LayoutField,
      customName: setName,
      customPayType: setPayType
    }

    const schema_2 = {
      title: "",
      type: "object",
      required: ["title","tel"],
      properties: {
        title: {type: "string", title: "ชื่อผู้ติดต่อ", default: "นาย", enum: ["นาย", "นาง", "นางสาว", "บจก.", "หจก."]},
        name: {type: "object"},
        tel: {type: "string", title: "หมายเลขโทรศัพท์"},
        other_tel: {type: "string", title: "เบอร์ติดต่ออื่น"},
        empty: {}
      }
    }
    const uiSchema_2 = {
      'ui:field': 'layout',
      'ui:layout': [
        { 
          title:{md:2},
          name:{md:4},
          tel:{md:6}
        },
        {
          empty:{md:6},
          other_tel:{md:6}
        }      
      ],
      name: {
        'ui:field': 'customName',
        'ui:title': true
      }
    }
    const setName_2 = function(props) {
      return(
              <FormGroup style={{marginTop:'10px'}}>             
                <FormControl

                >
                </FormControl>
              </FormGroup>
      )
    }
    const fields_2 = {      
      layout: LayoutField,
      customName: setName_2
    }  
    return(
        <div>
          <Box loading={false}>
            <Box.Header>
              <Box.Title border={true}>
                <FontAwsome className="text-blue" name="user" /> รายละเอียดลูกค้า
              </Box.Title>  
            </Box.Header>
            <Box.Body>
              <Row>
                <Col md={12}>
                  <FormJsonSchema 
                    schema={schema2}
                    uiSchema={uiSchema2}
                    fields={fields2}
                    formData=""
                    FieldTemplate={CustomFieldTemplate}         
                    onChange={this.onFormChange.bind(this)}
                  >
                    <div></div>
                  </FormJsonSchema>                  
                </Col>
              </Row>
            </Box.Body>
          </Box>
          <Box loading={false}>
            <Box.Header>
              <Box.Title border={true}>
                <FontAwsome className="text-blue" name="user" /> รายละเอียดผู้ติดต่อ
              </Box.Title>  
            </Box.Header>
            <Box.Body>
              <Row>
                <Col md={12}>
                  <FormJsonSchema 
                    schema={schema_2}
                    uiSchema={uiSchema_2}
                    fields={fields_2}
                    formData=""
                    FieldTemplate={CustomFieldTemplate}         
                    onChange={this.onFormChange.bind(this)}
                  >
                    <div></div>
                  </FormJsonSchema>                  
                </Col>
              </Row>
              <div className="pull-right">
                <Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;บันทึก</Button>
                &nbsp;
                <Button className="btn btn-default"><FontAwsome name='close' />&nbsp;ปิดใบงาน</Button>
              </div>
              <SWTNewCustomerPopup 
                show={this.state.showCustomerPopup} 
                onHide={()=>{this.setState({showCustomerPopup:false})}}
              />
            </Box.Body>
          </Box>
        </div>  
    )
  }

  renderTab3() {
    const schema3 = {
      title: "",
      type: "object",
      required: ["contact_date","tel"],
      properties: {
        contact_date: {type: "string", title: "วันที่ติดต่อขอเข้าซ่อม"},
        receiving_by: {type: "string", title: "ชื่อเจ้าหน้าที่ผู้รับรถ"},
        fixed_by: {type: "string", title: "ชื่อเจ้าหน้าที่ช่างซ่อม"},
        empty: {}
      }
    }
    const uiSchema3 = {
      'ui:field': 'layout',
      'ui:layout': [
        { 
          contact_date:{md:6},
          receiving_by:{md:6}
        },
        {
          empty:{md:6},
          fixed_by:{md:6}
        }       
      ],
      contact_date: {
        "ui:widget": "date",
      },
    }
    const fields3 = {      
      layout: LayoutField
    }  
    return(
        <div>
          <Box loading={false}>
            <Box.Header>
              <Box.Title border={true}>
                <FontAwsome className="text-blue" name="check-square-o" /> รับรถเข้าซ่อม
              </Box.Title>  
            </Box.Header>
            <Box.Body>
              <Row>
                <Col md={12}>
                  <FormJsonSchema 
                    schema={schema3}
                    uiSchema={uiSchema3}
                    fields={fields3}
                    formData=""
                    FieldTemplate={CustomFieldTemplate}         
                    onChange={this.onFormChange.bind(this)}
                  >
                    <div></div>
                  </FormJsonSchema>                  
                </Col>
              </Row>
              <div className="pull-right">
                <Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;บันทึก</Button>
                &nbsp;
                <Button className="btn btn-default"><FontAwsome name='close' />&nbsp;ปิดใบงาน</Button>
              </div>
            </Box.Body>
          </Box>
        </div>  
    )
  }

  renderTab4() {
    const schema4 = {
      title: "",
      type: "object",
      required: ["contact_date","tel"],
      properties: {
        delivering_date: {type: "string", title: "วันที่ลูกค้ามารับรถ"},
        delivering_name_as: {type: "object", title: "ชื่อผู้มารับรถ"},
        delivered_by: {type: "string", title: "ชื่อเจ้าหน้าที่ส่งมอบรถ"},
      }
    }
    const uiSchema4 = {
      'ui:field': 'layout',
      'ui:layout': [
        { 
          delivering_date:{md:6},
          delivering_name_as:{md:6}
        },
        {
          delivered_by:{md:6}
        }       
      ],
      delivering_date: {
        "ui:widget": "date"
      },
      delivering_name_as: {
        'ui:field': 'customDeliveringName',
      }
    }
    const setDeliveringName = function(props) {
      return(
              <FormGroup>
                <Radio
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label=" ใช้ชื่อลูกค้า"
                />
                {' '}
                <Radio
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label=" อื่นๆ"
                />
                <FormControl></FormControl>
              </FormGroup>
      )
    }
    const fields4 = {      
      layout: LayoutField,
      customDeliveringName: setDeliveringName
    }  
    return(
        <div>
          <Box loading={false}>
            <Box.Header>
              <Box.Title border={true}>
                <FontAwsome className="text-blue" name="smile-o" /> รายละเอียดการส่งมอบรถ
              </Box.Title>  
            </Box.Header>
            <Box.Body>
              <Row>
                <Col md={12}>
                  <FormJsonSchema 
                    schema={schema4}
                    uiSchema={uiSchema4}
                    fields={fields4}
                    formData=""
                    FieldTemplate={CustomFieldTemplate}         
                    onChange={this.onFormChange.bind(this)}
                  >
                    <div></div>
                  </FormJsonSchema>                  
                </Col>
              </Row>
              <div className="pull-right">
                <Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;บันทึก</Button>
                &nbsp;
                <Button className="btn btn-default"><FontAwsome name='close' />&nbsp;ปิดใบงาน</Button>
              </div>
            </Box.Body>
          </Box>
        </div>  
    )
  }

}  


export default WorkDocGenForm;


// WEBPACK FOOTER //
// ./src/view/workdoc/WorkDocGenForm.js